import React from "react";
import GenericSlider from "../GenericSlider";
import { assetImg } from "@/modules/moduleImporter";
import { isPortrait } from "@/modules/commonMobile";

import ButtonSwitch from "./ButtonSwitch";
import LanguagePicker from "../LanguagePicker";

import { ILanguageType, VideoQualityType } from "@/types/GlobalTypes";

import "./index.scss";
import { isIPhone } from "@/modules/iOSDetection";
import { langLiteralType } from "@/modules/locales";

interface IProps {
	langdata: ILanguageType;

	autoSubmitBet: boolean;
	autoRebet: boolean;
	enableSound: boolean;
	enableMusic: boolean;
	enableStreaming: boolean;

	musicVolume: number;
	soundVolume: number;

	langStr: langLiteralType;

	//Only for mobile
	visible?: boolean;
	mobile?: boolean;
	orientation?: string;
	noHeader?: boolean;
	noOverlay?: boolean;
	enableRotation?: boolean;
	alwaysShowLeftPane?: boolean;
	hideStreamingToggle?: (e: any) => void;
	toggleSettings?: (e: any) => void;

	toggleTooltipSettings?: (e: any) => void;
	updateSettings: (e: any) => void;
	updateLanguage: (e: any) => void;

	// Video quality support
	videoQuality: VideoQualityType;
	updateVideoQuality: (e: any) => void;

	showStreamingQuality?: boolean;
}

export default class SettingsForm extends React.Component<IProps> {
	get separator() {
		return <div className="separator" />;
	}

	render() {
		const {
			alwaysShowLeftPane,

			autoSubmitBet,
			autoRebet,
			hideStreamingToggle,
			enableRotation,
			enableStreaming,
			// showStreamingQuality,

			langStr,

			videoQuality,
			updateVideoQuality,

			langdata,
			enableSound,
			enableMusic,
			soundVolume,
			musicVolume,

			mobile,
			noOverlay,
			toggleSettings,
			toggleTooltipSettings,
			updateLanguage,
			updateSettings,
			orientation,
			noHeader,
			visible
		} = this.props;

		const blinking = (isPortrait() ? " blinking" : "");
		const showStreamingQuality = false;

		if (mobile && isPortrait() && !visible)
			return null;

		return <>
			{
				mobile && !noOverlay && visible ?
					<div key="overlay" style={{ position: "fixed", top: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.5)", zIndex: 10 }}
						onClick={toggleSettings} /> :
					null
			}

			<div key="primary"
				className={
					"tooltip-settings" +
					(mobile ? ` mobile ${orientation}` : "") +
					(visible ? " active" : "") +
					(isIPhone() ? " iphone" : "")
				}>
				{
					!noHeader &&
					<div className="tooltip-settings-header">
						{assetImg("sidemenu", "gear.svg", "", "sl-icon-footer")}

						<span className="label"> {langdata["txt_settings"]}</span>

						{mobile ?
							<span className="close" onClick={toggleSettings}>
								<i className={"sl-ic-close"} />
							</span> :
							<span className="close" onClick={toggleTooltipSettings}>
								<i className={"sl-ic-close"} />
							</span>
						}
					</div>
				}

				<div className="tooltip-settings-body">
					<div className="body-category">
						<div className="setting-label">
							{assetImg("sidemenu", "sfx.svg", "", "sl-icon-footer")}
							{/* <img className="sl-icon-footer"
								src={this.sidemenuIcons["sfx.svg"]}
								alt="sfx" /> */}

							<span className="label"> {langdata["txt_sounds"]}</span>
							<ButtonSwitch
								name="Sound"
								prop="sound"
								checked={enableSound}
								changeEvent={updateSettings}
							/>

							<GenericSlider
								defaultValue={50}
								min={1}
								max={100}
								value={soundVolume}

								prop="soundVolume"
								onChange={updateSettings}
							/>
						</div>

						{this.separator}

						<div className="setting-label">
							{assetImg("sidemenu", "music.svg", "", "sl-icon-footer")}

							<span className="label">
								{langdata["txt_music"]}
							</span>
							<ButtonSwitch
								name="Music"
								prop="music"
								checked={enableMusic}
								changeEvent={updateSettings}
							/>

							<GenericSlider
								defaultValue={50}
								min={1}
								max={100}
								value={musicVolume}

								prop="musicVolume"
								onChange={updateSettings}
							/>
						</div>

						{ /*Separator*/}
						<div className="thick-separator"></div>

						{ /* Enable this only on dev */}
						<div className="setting-label">
							{assetImg("sidemenu", "chip.svg", "", "sl-icon-footer")}

							<span className="label">
								{langdata["txt_auto_confirm_bet"]}
							</span>

							<ButtonSwitch
								name="AutoSubmit"
								prop="autoSubmitBet"
								checked={autoSubmitBet}
								changeEvent={updateSettings}
							/>
						</div>

						{this.separator}

						<div className="setting-label">
							{assetImg("sidemenu", "auto_rebet.svg", "", "sl-icon-footer")}

							<span className="label">
								{langdata["txt_auto_rebet"]}
							</span>

							<ButtonSwitch
								name="AutoRebet"
								prop="autoRebet"
								checked={autoRebet}
								changeEvent={updateSettings}
							/>
						</div>

						{this.separator}

						{
							!hideStreamingToggle && (
								<div className="setting-label">
									{assetImg("sidemenu", "video.svg", "", "sl-icon-footer")}

									<span className="label">
										{langdata["txt_video"]}
									</span>

									<ButtonSwitch
										name="Streaming"
										prop="streaming"
										checked={enableStreaming}
										changeEvent={updateSettings}
									/>
								</div>
							)
						}

						{
							showStreamingQuality && (
								<div className="setting-label">
									{assetImg("sidemenu", "video.svg", "", "sl-icon-footer" + blinking)}

									<span className={"label" + blinking}>
										Streaming Quality
									</span>

									<select value={videoQuality}
										onChange={updateVideoQuality}>
										<option value={"sd"}>
											SD
										</option>
										<option value={"hd"}>
											HD
										</option>
									</select>
								</div>
							)
						}

						{this.separator}

						{
							!alwaysShowLeftPane && mobile && (
								<div className="setting-label">
									{assetImg("sidemenu", "rotation.svg", "", "sl-icon-footer")}

									<span className="label">
										{langdata["txt_enable_rotation"]}
									</span>

									<ButtonSwitch
										name="Rotation"
										prop="rotation"
										checked={enableRotation}
										changeEvent={updateSettings}
									/>
								</div>
							)
						}

						{this.separator}

						<div className="setting-label">
							{assetImg("lang", langStr, "", "sl-icon-footer")}
							
							<span className="label">
								{langdata["txt_language"]}
							</span>

							<LanguagePicker
								langStr={langStr}
								updateLanguage={updateLanguage}
							/>
						</div>

					</div>
				</div>
			</div>
		</>;
	}
}
